<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៤.ក
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៤.ខ,គ,ឃ
      </v-tab>
      <v-tab-item>
        <div class="row">
          <div>
            <staffedu :data="sta_tra" :title="title[1]" :htext="pd[10]"/>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <staffmix :data="sta_mix" :title="title[2]" :htext="pd[10]"/>
            <staffFun :data="sta_ext" :title="title[4]" :htext="pd[10]"/>
          </div>
          <div>
            <extrasubject :data="sta_ess" :title="title[3]" />
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
//import staffAge from "@/components/privateascf/sharedCom/privStaffAge.vue";
//import staffService from "@/components/privateascf/sharedCom/privStaffService.vue";
import staffService from "@/components/privateascf/sharedCom/privStaffMix.vue";
import staffEducation from "@/components/privateascf/sharedCom/staffEducation.vue";
import extraSubject from "@/components/ascf/sec/extraSubjectSec.vue";
import privStaffTenTe from "@/components/privateascf/sharedCom/privStaffTenTe.vue";

import { pd } from "@/utils/zdesc/privDesc.js"

export default {
  props: [
    "title",
    //"sta_age",
    //"sta_ser",
    "sta_tra",
    "sta_ess",
    "sta_mix",
    "sta_ext",
  ],
  components: {
    //staffage: staffAge,    
    staffedu: staffEducation,
    staffmix: staffService,
    extrasubject: extraSubject,
    staffFun: privStaffTenTe,
  },
  data() {
    return {
      active_tab: 0,
      pd: pd
    };
  },
};
</script>
<style scoped>
.row {
  display: flex;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>